require('bootstrap');
const {isString} = require("../../public/vendor/datatables-plugins/pdfmake/pdfmake");
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
global.jQuery = window.$ = window.jQuery = require('jquery');

window.axios = require('axios');
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const metaTag = document.querySelector('meta[name="csrf-token"]');
let csrfToken = metaTag.getAttribute('content');

// Set the CSRF token as a default header for Axios
axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
window.refreshCsrfToken = () => {
    axios.get('/refresh-csrf-token').then(response => {
        // Update the CSRF token with the new one
        const newCsrfToken = response.data;
        csrfToken = newCsrfToken; // Update the CSRF token variable
        axios.defaults.headers.common['X-CSRF-TOKEN'] = newCsrfToken;

        // Update the meta tag content
        metaTag.setAttribute('content', newCsrfToken);
    }).catch(error => {
    });
}


global.toastr = window.toastr = require('toastr');
require('slick-carousel/slick/slick');
window.colors = ['#f0f0f0', '#e0e0e0', '#d0d0d0', '#c0c0c0', '#b0b0b0'];
window.currentColorIndex = 0;
//window.currentParent = null;
window.updateButton = (sku, type) => {
    const button = $(`#cart-button-${sku}`);
    const label = $(`#label-cart-${sku}`)
    button.data('process', type);
    if (type === 'update') {
        label.html(Lang.get(`messages.update_cart`))
        //button.removeClass('btn-success');
        //button.addClass('btn-primary');
    }
    if (type === 'add') {
        label.html(Lang.get(`messages.add_to_cart`))
        //button.removeClass('btn-primary');
        //button.addClass('btn-success');
    }
}
window.updateCart = (items_on_cart) => {
    const cartLabel = $(`#cart .badge`);
    cartLabel.html(items_on_cart);
}

window.updateCartTotals = (subtotal, shipping_cost, total, vat_amount) => {
    try {
        $("#subtotal").html(subtotal);
        $("#shipping_cost").html(shipping_cost);
        $("#total").html(total);
        $("#vat_amount").html(vat_amount);
    } catch (e) {

    }

}
window.addItemToCart = (requestData, qty) => {
    showLoader()
    // Define the data to send with the request
    const data = {
        sku: requestData.sku,
        qty: qty,
    };
    // Send an AJAX POST request to the server to add the item to the cart
    axios.post('/cart/add', data)
        .then((response) => {
            if (response.data.backorder || !response.data.response_type) {
                stopAutoCloseToastr();
                toastr.warning(response.data.success);
                enableAutoCloseToastr();
            } else {
                toastr.success(response.data.success);
            }

            updateButton(requestData.hash_id, 'update')
            updateCart(response.data.items_on_cart)

            hideLoader()
        })
        .catch((error) => {
            stopAutoCloseToastr();
            toastr.error(error.response.data.error)
            enableAutoCloseToastr();
            hideLoader()
        });
};
window.updateCartQuantity = (requestData, newQuantity, row = null) => {
    showLoader()
    const data = {
        sku: requestData.sku,
        qty: newQuantity,
    };

    axios.put(`/cart/update/${data.sku}`, data)
        .then(response => {
            if (response.data.backorder || !response.data.response_type) {
                stopAutoCloseToastr();
                toastr.warning(response.data.success);
                enableAutoCloseToastr();
            } else {
                toastr.success(response.data.success);
            }
            updateCart(response.data.items_on_cart)
            if (response.data.reload && !row) {
                updateButton(requestData.hash_id, 'add');
            }
            if (row) {
                if (response.data.items_on_cart === 0) {
                    location.reload();
                }
                const id = row.index();
                if (response.data.current_qty <= 0) {
                    row.remove();
                } else {
                    row.cell(id, 'row_total:name').data(response.data.current_row_total);
                    row.cell(id, 'hidden_order_qty:name').data(response.data.current_qty);
                    $(`#row-${requestData.hash_id}-backorder`).html(response.data.backorder)
                    $(`#row-${requestData.hash_id}-qty`).val(response.data.current_qty);
                }
                table.draw();
            }
            updateCartTotals(response.data.subtotal, response.data.shipping_cost, response.data.total, response.data.vat_amount)
            hideLoader();
            /*      setTimeout(function () {
                      window.location.reload();
                  }, 3000);*/

        })
        .catch(error => {

            if (error.response !== undefined) {
                stopAutoCloseToastr();
                toastr.error(error.response.data.error);
                enableAutoCloseToastr();
            }
            table.draw();
            hideLoader()
        });

};
window.removeFromCart = (sku, row = null) => {
    showLoader()
    const data = {
        sku: sku,
    };
    axios.put(`/cart/remove/${sku}`, data)
        .then(response => {

            if (response.data.items_on_cart === 0) {
                location.reload();
            }
            toastr.success(response.data.success)
            updateCart(response.data.items_on_cart)
            if (row) {
                row.remove();
                table.draw();
            }
            updateCartTotals(response.data.subtotal, response.data.shipping_cost, response.data.total, response.data.vat_amount)
            hideLoader()
        })
        .catch(error => {
            toastr.error(error.response.data.error);
            hideLoader()
        });
}

window.stopAutoCloseToastr = () => {
    toastr.options.closeButton = true;
    toastr.options.timeOut = 0;
    toastr.options.extendedTimeOut = 0;
}
window.enableAutoCloseToastr = () => {
    toastr.options.closeButton = false;
    toastr.options.timeOut = 5000;
    toastr.options.extendedTimeOut = 1000;
}
window.placeOrder = () => {
    showLoader()
    const data = {
        shipping_address: $('#shippingAddress').val(),
        comments: $('#comments').val(),
        shipping_method: $('input[name="shipping_method"]:checked').attr('id'),
        payment_method: $('#paymentMethod').val()
    };
    axios.post(`/cart/placeOrder`, data)
        .then(response => {
            if (response.data.success) {
                window.location.href = response.data.redirect
            }
            hideLoader()
        })
        .catch(error => {
            if (error.response.data.errors) {
                Object.keys(error.response.data.errors).forEach((key) => {
                    error.response.data.errors[key].forEach((error) => {
                        toastr.error(error)
                    });
                })
            } else {
                toastr.error(error.response.data.error)
            }

            hideLoader()
        });
}

window.reorder = (order) => {
    showLoader()

    axios.post(`/customer/order/${order}/reorder`)
        .then(response => {
            toastr.success(response.data.success)
            updateCart(response.data.items_on_cart)
            hideLoader()
        })
        .catch(error => {
            if (error.response.data.errors) {
                Object.keys(error.response.data.errors).forEach((key) => {
                    error.response.data.errors[key].forEach((error) => {
                        toastr.error(error)
                    });
                })
            } else {
                toastr.error(error.response.data.error)
            }

            hideLoader()
        });
}
window.showLoader = function () {
    $('.loader-container').fadeIn();
};
window.hideLoader = function () {
    $('.loader-container').fadeOut();
}

window.autocomplete = (query) => {
    const data = {
        query: query
    };
}
window.toggleDeliveryAddressVisibility = () => {
    const selectedRadio = $('input[name="shipping_method"]:checked').attr('id');
    if (selectedRadio === 'pick_up') {
        $('#shipping_address_section').hide()
    } else {
        $('#shipping_address_section').show()
    }
    const data = {
        'shipping_method': selectedRadio
    }

    showLoader();
    axios.post('/cart/updateDelivery', data)
        .then(response => {
            updateCartTotals(response.data.subtotal, response.data.shipping_cost, response.data.total, response.data.vat_amount)
        }).catch()
    hideLoader();

}

window.getLocaleThousandAndDecimalSeparators = (priceString, locale) => {
    const formatter = new Intl.NumberFormat(locale);
    const parts = formatter.formatToParts(priceString); // Use a number with a decimal point

    let thousandSeparator, decimalSeparator;
    for (const part of parts) {
        if (part.type === "group") {
            thousandSeparator = part.value;
        } else if (part.type === "decimal") {
            decimalSeparator = part.value;
        }
    }

    return {
        thousandSeparator: thousandSeparator || '.',
        decimalSeparator: decimalSeparator || ',',
    };
}

window.parsePriceString = (priceString, locale) => {
    if (typeof priceString === 'string') {
        const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: 'EUR', // Change the currency code as needed,
        });
        const parts = formatter.formatToParts(0);
        const currencySymbol = parts.find(part => part.type === 'currency')?.value || '€';
        const groupSeparator = parts.find(part => part.type === 'group')?.value || '.';
        const separator = parts.find(part => part.type === 'decimal')?.value || ',';
        const numericString = priceString.toString()
            .replace(currencySymbol, '')
            .replace(new RegExp('\\' + groupSeparator, 'g'), '')
            .replace(new RegExp('\\' + separator, 'g'), '.')
            .replace(/[^\d.-]/g, '');
        return parseFloat(numericString);
    }
    return priceString;
}

window.updateDataTableSelector = () => {
    try {
        if (table !== undefined) {
            if (window.matchMedia('(max-width: 767px)').matches) {
                table.select.selector('td:not(:first-child)');
            } else {
                table.select.selector('td:not(:nth-last-child(-n+2))');
            }
        }
    } catch (e) {

    }
}
window.addEventListener('resize', updateDataTableSelector);

window.saveAddress = () => {
    showLoader()
    const form = $('#data-form');
    let data = {};
    form.find('input, select').each(function () {
        const inputName = $(this).attr('name');
        if ($(this).is(':checkbox')) {
            data[inputName] = $(this).prop('checked') ? 1 : 0;
        } else {
            data[inputName] = $(this).val();
        }
    });


    axios.post('/customer/delivery_address/save', data)
        .then(response => {
            toastr.success(response.data.message)
            if (response.data.reload) {
                window.location.href = response.data.redirect
            }
        })
        .catch(error => {
            if (error.response.status === 422) {
                const errors = error.response.data.errors;
                for (const field in errors) {
                    if (errors.hasOwnProperty(field)) {
                        const errorMessages = errors[field].join('<br>');
                        const inputField = document.querySelector(`[name="${field}"]`);
                        inputField.classList.add('is-invalid');
                        let errorElement = document.getElementById(`${field}-error`);
                        if (!errorElement) {
                            errorElement = document.createElement('div');
                            errorElement.className = 'text-danger';
                            errorElement.id = `${field}-error`;
                            inputField.parentNode.parentNode.appendChild(errorElement);
                        }
                        errorElement.innerHTML = errorMessages;
                    }
                }
            }
        });
    hideLoader()
}

window.viewProductDetails = (sku) => {
    showLoader();
    axios.post(`/brand/${sku}/details`)
        .then(response => {
            let sliderContent = '';
            $(".modal-title").html(response.data.title);
            $(".description").html(response.data.description);
            $('#table-details').hide(); // Show the table
            if (response.data.details) {
                $("#table-details tbody").empty()
                response.data.details.forEach(function (item) {
                    $("#table-details tbody").append(`<tr><td>${item.label}</td><td>${item.value}</td></tr>`)
                });
                $('#table-details').show(); // Show the table
            }
            if (response.data.images) {
                try {
                    response.data.images.forEach(function (imageUrl) {
                        sliderContent += '<div class=""><img src="' + imageUrl + '"></div>';
                    });
                    const slider = $("#slider");
                    try {
                        slider.slick('unslick').slick('reinit')
                    } catch (e) {
                    }
                    slider.html(sliderContent);
                    slider.slick({
                        dots: true, // Add pagination dots
                        arrows: true, // Add navigation arrows
                        infinite: true, // Loop the carousel
                        variableWidth: true,
                        centerMode: true,
                        slidesToShow: 1, // Number of slides to show at a time
                        slidesToScroll: 1, // Number of slides to scroll at a time
                        responsive: [
                            {
                                breakpoint: 768, // Adjust settings for screens with a width less than 768px
                                settings: {
                                    slidesToShow: 1, // Number of slides to show for mobile
                                    slidesToScroll: 1, // Number of slides to scroll for mobile
                                },
                            },
                        ],
                    });
                    slider.slick("refresh");

                } catch (e) {
                    console.log(e)
                }
            }
            $("#product-details").modal('show');
            $("#product-details").addClass('show');
        })
        .catch(error => {
            $("#product-details").removeClass('show');
            toastr.error(Lang.get(`messages.error_detail_product`));
        });

    hideLoader();
}
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     wsHost: import.meta.env.VITE_PUSHER_HOST ?? `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });
